import { gql } from '@apollo/client';
import { DocumentFragment } from 'approot/shared/graphql/document/document.graphql';

export const studentLessonPrintablesFragment = gql`
  fragment StudentLessonPrintablesFragment on Lesson {
    id
    printableVocabularyEnSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableVocabularyEsSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
  }
  ${DocumentFragment}
`;
